import { Component, Input, OnInit } from '@angular/core';
// import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
// import dragula from 'dragula';
// import autoScroll from 'dom-autoscroller';



/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'riordinanew_3',
  templateUrl: 'riordinanew_3.html',
})

export class RiordinaNew_3Component implements OnInit {
  risp1 = [];
  @Input('domanda') domanda: any; 
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  items_: any;
  question: any;
  risposte_conferma = [];
  showconferma: boolean = true;
  feed = '';
  lista_risposte = [];
  showtime: boolean = true;
  // scroll: any;
  constructor( public events: Events,public translate: TranslateService) {
    // constructor( public events: Events) {
    this.output = 'test string';

   
  }

  clone(obj) {
    let copy = (JSON.parse(JSON.stringify(obj)));
    return copy;
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
  // ngOnDestroy() {
  //   this._DRAG.destroy('baga');
  //   this.scroll.destroy();
  // }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    // let drake = dragula();
    // this._DRAG.add('baga', drake); 

    // this.scroll = autoScroll(
    //   // can also be an array of elements if they're { overflow: auto; max-height: XXpx } containers.
    //   // i.e. [someViewChild.nativeElement]
    //   window,
    //   {
    //     margin: 30,
    //     maxSpeed: 25,
    //     scrollWhenOutside: true,
          
    //     autoScroll: function () { // don't use () => {} syntax, we want to keep the 'this'
    //       // Only scroll when the pointer is down, and there is a child being dragged. 
    //       return this.down && drake.dragging;
    //     }
    //   });

    //console.log('-----------------settings', this.settingsmq);
    this.events.publish('start_tempo', this.domanda);
    this.question = this.clone(this.domanda);
    //if (this.mq.risposteCausali == '1')
    this.lista_risposte = this.shuffle(this.domanda['RispostaMicroStepList']);
    /*else
      this.lista_risposte = this.domanda['RispostaMicroStepList'];
    */
    var ind = 0;
    for (let d of this.lista_risposte) {
      // this.risposte_conferma.push(d.id);
      d['numberx'] = ind + 1;
      ind++;
    }
    //console.log('oninit', this.domanda);
    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
  }
  ionViewDidEnter() {
    //console.log('didenter', this.domanda);
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    var x = document.getElementsByClassName("rightindex");
    var altezze = [];
    for (let i = 0; i < this.lista_risposte.length; i++) {
      let r = this.lista_risposte[i];

      var hradio = document.getElementById('content-list_' + r.id).offsetHeight;
      altezze[r.id] = hradio + 3;

      /*var radio_icon = document.getElementById(r.id).children[0];
      radio_icon.setAttribute("style", "height:" + hradio + "px !important");
      radio_icon.children[0].setAttribute("style", "height:" + (hradio - 22) + "px !important");*/
    }
    for (var i = 0; i < x.length; i++) {
      var l = x[i];
      if(l != undefined){
        l.setAttribute("style", "height:" + altezze[l['id']] + "px !important");
        l.children[0].setAttribute("style", "margin-top:" + ((altezze[l['id']] - 10) / 2 - 17) + "px !important");
      }
    }
  }
  onDrop(indexes) {

    // Reset the items array
    // this.items_ = [];
    
    let element = this.lista_risposte[indexes.from];
    this.lista_risposte.splice(indexes.from, 1);
    this.lista_risposte.splice(indexes.to, 0, element);
    // //console.log(this.lista_risposte);
    // Iterate through the retrieved list data

    // for(let oll = 0;oll < this.lista_risposte.length;oll++){
    // this.lista_risposte[oll]['numberx'] = oll++;
    // var y = document.getElementById("numx_"+this.lista_risposte[oll].id);
    // var y = document.getElementsByClassName("list_number");
    // for (var h = 0; h < y.length; h++) {
    //   var l = y[h];
    //   l.innerHTML = ''+h++;
    // }
    // y.innerHTML = ''+oll++;
    // }

    var xxc = 0;
    this.lista_risposte.forEach((item) => {
      // Do we have data?

      if (item.id !== undefined) {
        var y = document.getElementsByClassName("list_number_" + item.id);
        //console.log(y);
        y[0].innerHTML = ''+(xxc+1);
        xxc++;
        // Re-populate the items array with new list order
        // this.items_.push(item.id);
      }

    });


    // this.risposte_conferma = this.items_;

  }


  // touchmove() {
  //   // do nothing
  // }

  conferma(tempo?) {
    // //console.log('drag--->', this._DRAG);
    //if(this._DRAG)
    //this._DRAG.destroy('baga');
    // const bag: any = this._DRAG.find('baga');
    // if (bag !== undefined) { this._DRAG.destroy('baga'); }

    // this.lista_risposte.foreach()
    // //console.log(this.risposte_conferma);
    var allreorder = document.getElementsByTagName("ion-reorder");
    for (var i = 0; i < allreorder.length; i++) {
      allreorder[i].classList.add('xhide');
    }
    this.risposte_conferma = [];
    this.events.publish('stop_tempo_parziale', this.domanda);
    let risp_esatte = [];
    let risp_errate = [];
    for (let i = 0; i < this.question['RispostaMicroStepList'].length; i++) {

      let resatta = this.question['RispostaMicroStepList'][i];
      // let rdata = this.risposte_conferma[i];
      let rdata = this.lista_risposte[i].id;
      this.risposte_conferma.push(this.lista_risposte[i].id);
      //console.log(resatta);
      //console.log(rdata);
      if (resatta.id === rdata)
        risp_esatte.push(resatta.id);
      else
        risp_errate.push(rdata);
    }

    //console.log(this.risposte_conferma);
    //console.log('esatte', risp_esatte);
    //console.log('errate', risp_errate);
    if (!this.settingsmq['istest'])
      this.changestyle(risp_esatte, risp_errate);

    if (risp_esatte.length == 0)
      this.feed = this.domanda['feedbackNegativo'];
    else if (risp_errate.length == 0)
      this.feed = this.domanda['feedbackPositivo'];
    else
      this.feed = this.domanda['feedbackParziale'];
    this.showconferma = false;
    if (this.settingsmq['istest'])
      this.prosegui();
  }
  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('riordina', this.question, this.risposte_conferma);
  }



  changestyle(esatte, errate) {

    var y = document.getElementsByClassName("circle_number");
    var h;
    for (h = 0; h < y.length; h++) {
      var l = y[h];
      if (esatte.indexOf(l['id']) != -1 || errate.indexOf(l['id']) != -1)
        l.classList.add('whitefillstroke');
    }

    var z = document.getElementsByClassName("list_number");
    var u;
    for (u = 0; u < z.length; u++) {
      var l = z[u];
      if (esatte.indexOf(l['id']) != -1 || errate.indexOf(l['id']) != -1)
        l.classList.add('whitefillstroke');
    }

    var x = document.getElementsByClassName("rightindex");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];
      if (esatte.indexOf(l['id']) != -1)
        l.classList.add('green');
      if (errate.indexOf(l['id']) != -1)
        l.classList.add('red');
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/msteps/riordinanew_3.ts